// Auto-generated from .env — do not commit
export const environment = {
  "apiUrl": "https://jcca-api.roraima.dev",
  "sentryDsn": "https://a6c88b8e2152018a856a5d08586fa9bd@o4505083096989696.ingest.us.sentry.io/4511294870454272",
  "azureStorageUrlPrefix": "https://jcca.blob.core.windows.net/jcca-storage",
  "azureStorageSasUrl": "https://jcca.blob.core.windows.net/jcca-storage?sp=racwdl&st=2026-09-03T22:45:42Z&se=2026-12-01T07:00:42Z&spr=https&sv=2026-02-06&sr=c&sig=GfMGpVS1MlWGOHVt490B6ooc4lxivarHteo39TUYVBo%3D"
};
